import { useQuery } from '@tanstack/react-query';
import { StatusCode } from 'status-code-enum';
import { getApiV2BundleModifyReasons } from './get-api-v2-bundle_modify_reasons';

export { type BundleModifyReason as Reason } from './get-api-v2-bundle_modify_reasons';

export function useBundleModifyReasons() {
  return useQuery({
    queryKey: ['bundle modify reason'],
    queryFn: async () => {
      const resp = await getApiV2BundleModifyReasons();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
  });
}
